import React from "react";

const ReadingList = () => {
  return (
    <div style={styles.container}>
      <h1>📚 Reading List</h1>
      <p>This is where users will manage their personal library.</p>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#0f0f0f",
    color: "#ffffff",
    padding: "2rem",
    textAlign: "center",
  },
};

export default ReadingList;
